import { FaPlane } from "react-icons/fa";
import { Customized, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

export default function AltitudeGraph({ positions,progress }) {

  const flightData = [...positions]
  .reverse()
  .map(p => ({
    Time: p.date,
    Altitude: p.altitudeFt
  }));
  const lastIndex = flightData.length - 1;

  const CustomDot = (props) => {
    const { cx, cy, index } = props;

    // Only show plane on last point
    if (index !== lastIndex) return null;

    return (
      <FaPlane
        style={{
          // position: "absolute",
          // transform: "translate(-50%, -50%) rotate(45deg)",
          fontSize: "15px",
          color: "#007bff",
        }}
        x={cx-10}
        y={cy-7}
      />
    );
  };

  return (
    <div 
  style={{ 
    width: "100%", 
    background: "#b6cdff2a",      // Full background bar (optional)
    height: "100px",
    position: "relative",
    borderRadius: "6px",
    overflow: "hidden"
  }}
>
    <div style={{ width: `${progress}%`,height:"100px", position: "relative" ,background:"#b6cdff50",borderRight:"1px solid #405ef2ff"}}>
      <ResponsiveContainer>
        <LineChart data={flightData}>
          <XAxis dataKey="Time" hide />
          <YAxis dataKey="Altitude" fontSize={'12px'} hide/>
          <Tooltip labelStyle={{fontSize:"12px"}} />
          <Line
            type="monotone"
            dataKey="Altitude"
            stroke="#007bff"
            strokeWidth={1.6}
            dot={<CustomDot />}   // ✅ Custom dot only on last altitude
          />
        </LineChart>
      </ResponsiveContainer>
      </div>
      
      </div>
  );
}
